import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
import { trackPromise } from 'react-promise-tracker';
import { confirmEmail } from '../../utils/AccountsAPI';
import { toastSuccess, toastError } from '../../utils/Functions';

const themeBlue = '#1976D2';
const themeGreen = '#388E3C';
const themeRed = '#E64A19';
const themeOrange = '#FFA000';
const themeGrey = '#455A64';

const useStyles = makeStyles((theme) => ({
  //for material UI Icons
  confirmEmail: {
    padding: '15px',
  },
  header: {
    marginTop: '15vh',
  },
  paper: {
    margin: 'auto',
    height: '100%',
    minWidth: '200px',
    maxWidth: '200px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'flex',
    verticalAlign: 'middle',
    marginLeft: theme.spacing(2),
  },
  textPaper: {
    minWidth: '200px',
    minHeight: '125px',
    maxWidth: '600px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'flex',
    backgroundColor: themeGrey,
    color: 'white',
  },
  elementPaper: {
    minWidth: '200px',
    minHeight: '125px',
    maxWidth: '800px',
    padding: theme.spacing(2),
    border: '5px',
    textAlign: 'center',
    display: 'flex',
  },
  cardContent: {
    color: 'white',
    fontSize: '1.75em',
    padding: '1vh',
    fontWeight: 'bold',
    verticalAlign: 'middle',
    width: '100%',
    margin: 'auto',
  },
  blue: {
    backgroundColor: themeBlue,
  },
  green: {
    backgroundColor: themeGreen,
  },
  red: {
    backgroundColor: themeRed,
  },
  orange: {
    backgroundColor: themeOrange,
  },
  grey: {
    backgroundColor: themeGrey,
  },
}));

export default function ConfirmEmail(props) {
  const [confirmed, setConfirmed] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    var query = props.location.search;

    const userId = query.substring(query.indexOf('?userId=') + 7, query.indexOf('&token='));

    const token = query.substring(query.indexOf('&token=') + 7);

    trackPromise(confirmEmail(userId, token)).then(
      () => {
        toastSuccess(props.toast, 'Email confirmed. Please login to use the site.');
        setConfirmed(true);
      },
      (err) => {
        toastError(props.toast, err);
      }
    );
  }, [props.location.search, props.toast]);

  return (
    <div className={classes.confirmEmail}>
      <Typography className={classes.header} variant='h3'>
        Confirm Email
      </Typography>

      <br />
      <Grid container direction='row' spacing={3} justify='center'>
        <Paper className={classes.elementPaper}>
          <Paper className={classes.textPaper}>
            <Typography>
              We have sent an email with a confirmation link to your email address. In order to log in to our system, please click the confirmation
              link.
              <br />
              <br />
              You will be prompted to login on a successful confirmation.
            </Typography>
          </Paper>

          {confirmed ? (
            <span
              className='pointer'
              onClick={() => {
                props.history.push('/Login');
              }}
            >
              <Paper className={clsx(classes.paper, 'hover', classes.blue)}>
                <div className={classes.cardContent}>Login</div>
              </Paper>
            </span>
          ) : null}
        </Paper>
      </Grid>
    </div>
  );
}
